module.exports = "/_next/static/images/uv-base-031e5c73968fa1dae408e10debf840db.jpg";